import React from 'react';
import './primary-button.scss';
import AppConfigurationService from '@services/app-configuration-service/app-configuration-service';
import addRightArrowWithCircle from '@assets/right_arrow_with_circle.svg';
import addRightArrowWithCircleDisabled from '@assets/right_arrow_with_circle_disabled.svg';

interface Props {
    theme?: string;
    ariaLabel?: string;
    role?: string;
    testId?: string;
    disabled?: boolean;
    id?: string;
    hideChevron?: boolean;
    isNvc?: boolean;
    isLincoln?: boolean;
    showCircleArrowIcon?: boolean;
    newLincolnButton?: boolean;
}

interface ChevronIconProps {
    showCircleArrowIcon?: boolean;
    disabled?: boolean;
}

const ChevronIcon = (props: ChevronIconProps) => {
    const { showCircleArrowIcon, disabled } = props;

    return (
        <span className="fds-icon fds-icon--offset-right">
            {showCircleArrowIcon ? (
                <img
                    aria-hidden="true"
                    src={
                        disabled
                            ? addRightArrowWithCircleDisabled
                            : addRightArrowWithCircle
                    }
                    alt=""
                />
            ) : (
                <span className="fds-font--ford-icons__chevron-right"></span>
            )}
        </span>
    );
};

const PrimaryButton = (props: Props & React.HTMLProps<HTMLButtonElement>) => {
    const isLincoln = new AppConfigurationService().brand === 'lincoln';
    const disabledState: { disabled?: boolean } = {};
    let disabledClass = '';

    if (props.disabled) {
        disabledClass = 'disabled';
        disabledState.disabled = true;
    }

    const generateClassName = (): string => {
        let className = 'fmc-button fmc-button--no-shadow';

        if (props.className) {
            className += ` ${props.className}`;
        }

        if (isLincoln && (props.isNvc || props.newLincolnButton)) {
            className = 'lincoln-primary-button';
        }

        return className;
    };

    return (
        <button
            className={`${generateClassName()} ${disabledClass}`}
            onClick={props.onClick}
            style={props.style}
            data-dark={props.theme === 'dark' ? true : null}
            aria-label={props.ariaLabel}
            role={props.role}
            data-testid={props.testId}
            id={props.id}
            {...disabledState}
        >
            {props.children}{' '}
            {isLincoln && !props.hideChevron ? (
                <ChevronIcon
                    showCircleArrowIcon={props.showCircleArrowIcon}
                    disabled={disabledState.disabled}
                />
            ) : null}
        </button>
    );
};

export default PrimaryButton;
